import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';

import { MgImageModule } from '@app/src/app/components/MgImage';
import { MgIconModule } from '@app/src/app/icon';

import { TextModule } from '@shared/components/text';

import { SaTileComponent } from './components/sa-tile/sa-tile.component';
import { TooltipModule } from '@app/src/app/shared/components/tooltip';

@NgModule({
  declarations: [SaTileComponent],
  exports: [SaTileComponent],
  imports: [CommonModule, TextModule, MgImageModule, MgIconModule, FlexLayoutModule, TooltipModule],
})
export class SaSharedModule {}
